import React from "react";
import { Link } from "react-router-dom";

const Newsletter = () => {
  return (
    <section className="newsletter">
      <div className=" w-60 m-auto">
        <h2>Subscribe Our Newsletter</h2>
      </div>
      <div className="subscribe">
        {/* <input type="text" placeholder="Email" />*/}
        <Link
          className="btn"
          to="https://docs.google.com/forms/d/e/1FAIpQLSdhEffAoiHkQJeWa4PPz7EcyZk8R08TFPqVQonv-yRqUiJ4oQ/viewform?embedded=true"
        >
          Subscribe
        </Link>
      </div>
    </section>
  );
};

export default Newsletter;
